export default [
	{
		modulo: 0,
		privilegio: 0,
		routerName: 'inicio',
		routerPath: '/inicio',
		componentName: 'Inicio',
		componentPath: 'modules/layout/inicio/main'
	}
]
